import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  Button
} from '@one-thd/sui-atomic-components';
import NullViewTexts from '../../../constants/NullViewTexts';
import { NAVIGATION_URLS } from '../../../constants/navigationUrls';

const NullViewContent = ({ carousel }) => {
  const {
    cardTitle,
    benefits,
    learnMoreText
  } = NullViewTexts;

  return (
    <div
      data-testid="null-view-content"
      className={classNames(
        'sui-flex sui-flex-col sui-grow sui-justify-between sui-mb-2',
        {
          'sui-ml-4 sui-p-2 sui-max-w-96 sui-gap-2 sui-h-full': carousel,
          'sui-gap-2 @lg:sui-gap-4': !carousel
        }
      )}
    >
      <div
        className="sui-flex sui-flex-col"
      >
        {
          cardTitle.map((line, index) => {
            return (
              <h3
                key={`title-line-${index+1}`}
                className={classNames(
                  'sui-font-display sui-text-pretty',
                  {
                    'sui-text-3xl': carousel,
                    'sui-text-3xl @4xl:sui-text-6xl': !carousel
                  }
                )}
              >
                {line}
              </h3>
            );
          })
        }
      </div>
      <p
        className={classNames(
          'sui-text-base sui-text-balanced',
          {
            'sui-mb-4': !carousel
          }
        )}
      >
        {benefits.map((sentence, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <React.Fragment key={i}>
            {sentence}{i < benefits.length - 1 && <br />}
          </React.Fragment>
        ))}
      </p>
      {
        carousel && (
          <Button
            variant="text"
            href={NAVIGATION_URLS.LEARN_MORE}
          >
            {learnMoreText}
          </Button>
        )
      }
    </div>
  );
};

NullViewContent.propTypes = {
  carousel: PropTypes.bool
};

NullViewContent.defaultProps = {
  carousel: false
};

export default NullViewContent;